var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "DeliveryCode-EditTable" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading"
          }
        ],
        staticClass: "tabel-warp"
      },
      [
        _c(
          "vxe-table",
          {
            ref: "vxeTable",
            attrs: {
              align: "center",
              border: "",
              data: _vm.tabelData,
              "column-config": _vm.columnConfig,
              "row-config": { isHover: true },
              round: "",
              size: "small",
              "tooltip-config": {
                showAll: true
              },
              stripe: "",
              "edit-config": _vm.editConfig,
              "keep-source": "",
              "edit-rules": _vm.vxeRules,
              height: "100%"
            }
          },
          [
            _c("vxe-column", {
              attrs: {
                "min-width": "120",
                "edit-render": { enabled: _vm.canEdit }
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "el-button",
                        {
                          staticClass: "editOrderButton",
                          attrs: { type: "primary", size: "small" },
                          on: {
                            click: function($event) {
                              return _vm.handleRowPrint(scope.row)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("publics.btn.print")))]
                      )
                    ]
                  }
                }
              ])
            }),
            _c("vxe-column", {
              attrs: {
                field: "BARCODE",
                title: _vm.$t("EditTable.BARCODE"),
                "min-width": "200",
                "edit-render": { enabled: _vm.canEdit }
              },
              scopedSlots: _vm._u([
                {
                  key: "edit",
                  fn: function(ref) {
                    var row = ref.row
                    return [
                      _c("vxe-input", {
                        attrs: { type: "text", disabled: true },
                        model: {
                          value: row.BARCODE,
                          callback: function($$v) {
                            _vm.$set(row, "BARCODE", $$v)
                          },
                          expression: "row.BARCODE"
                        }
                      })
                    ]
                  }
                }
              ])
            }),
            _c("vxe-column", {
              attrs: {
                field: "PART_NO",
                title: _vm.$t("EditTable.PART_NO"),
                "min-width": "160",
                "edit-render": { enabled: _vm.canEdit }
              },
              scopedSlots: _vm._u([
                {
                  key: "edit",
                  fn: function(ref) {
                    var row = ref.row
                    return [
                      _c("vxe-input", {
                        attrs: { type: "text", disabled: true },
                        model: {
                          value: row.PART_NO,
                          callback: function($$v) {
                            _vm.$set(row, "PART_NO", $$v)
                          },
                          expression: "row.PART_NO"
                        }
                      })
                    ]
                  }
                }
              ])
            }),
            _c("vxe-column", {
              attrs: {
                field: "PART_NAME",
                title: _vm.$t("EditTable.PART_NAME"),
                "min-width": "200",
                "edit-render": { enabled: _vm.canEdit }
              },
              scopedSlots: _vm._u([
                {
                  key: "edit",
                  fn: function(ref) {
                    var row = ref.row
                    return [
                      _c("vxe-input", {
                        attrs: { type: "text", disabled: true },
                        model: {
                          value: row.PART_NAME,
                          callback: function($$v) {
                            _vm.$set(row, "PART_NAME", $$v)
                          },
                          expression: "row.PART_NAME"
                        }
                      })
                    ]
                  }
                }
              ])
            }),
            _c("vxe-column", {
              attrs: {
                field: "PART_DESCR",
                title: _vm.$t("EditTable.PART_DESCR"),
                "min-width": "180",
                "show-overflow": "ellipsis",
                "edit-render": { enabled: _vm.canEdit }
              },
              scopedSlots: _vm._u([
                {
                  key: "edit",
                  fn: function(ref) {
                    var row = ref.row
                    return [
                      _c("vxe-input", {
                        attrs: { type: "text", disabled: true },
                        model: {
                          value: row.PART_DESCR,
                          callback: function($$v) {
                            _vm.$set(row, "PART_DESCR", $$v)
                          },
                          expression: "row.PART_DESCR"
                        }
                      })
                    ]
                  }
                }
              ])
            }),
            _c("vxe-column", {
              attrs: {
                field: "PACKING_QTY",
                title: _vm.$t("EditTable.PACKING_QTY"),
                "min-width": "120",
                "edit-render": { enabled: _vm.canEdit }
              },
              scopedSlots: _vm._u([
                {
                  key: "edit",
                  fn: function(ref) {
                    var row = ref.row
                    return [
                      _c("vxe-input", {
                        attrs: { type: "text", disabled: true },
                        model: {
                          value: row.PACKING_QTY,
                          callback: function($$v) {
                            _vm.$set(row, "PACKING_QTY", $$v)
                          },
                          expression: "row.PACKING_QTY"
                        }
                      })
                    ]
                  }
                }
              ])
            }),
            _c("vxe-column", {
              attrs: {
                field: "QTY",
                title: _vm.$t("EditTable.QTY"),
                "min-width": "120",
                "edit-render": { enabled: _vm.canEdit }
              },
              scopedSlots: _vm._u([
                {
                  key: "edit",
                  fn: function(ref) {
                    var row = ref.row
                    return [
                      _c("vxe-input", {
                        attrs: { type: "text", disabled: true },
                        model: {
                          value: row.PO_REMAINING_QTY,
                          callback: function($$v) {
                            _vm.$set(row, "PO_REMAINING_QTY", $$v)
                          },
                          expression: "row.PO_REMAINING_QTY"
                        }
                      })
                    ]
                  }
                }
              ])
            }),
            _c("vxe-column", {
              attrs: {
                field: "TOTAL_QTY",
                title: _vm.$t("EditTable.TOTAL_QTY"),
                "min-width": "150",
                "edit-render": {
                  enabled: _vm.canEdit,
                  autofocus: ".vxe-input--inner"
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "edit",
                  fn: function(ref) {
                    var row = ref.row
                    return [
                      _c("vxe-input", {
                        attrs: { type: "number", disabled: false },
                        model: {
                          value: row.SPQ,
                          callback: function($$v) {
                            _vm.$set(row, "SPQ", $$v)
                          },
                          expression: "row.SPQ"
                        }
                      })
                    ]
                  }
                }
              ])
            }),
            _c("vxe-column", {
              attrs: {
                field: "PO_UNIT",
                title: _vm.$t("EditTable.PO_UNIT"),
                "min-width": "150",
                "edit-render": {
                  enabled: _vm.canEdit,
                  autofocus: ".vxe-input--inner"
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "edit",
                  fn: function(ref) {
                    var row = ref.row
                    return [
                      _c("vxe-input", {
                        attrs: { type: "text", disabled: false },
                        model: {
                          value: row.PO_UNIT,
                          callback: function($$v) {
                            _vm.$set(row, "PO_UNIT", $$v)
                          },
                          expression: "row.PO_UNIT"
                        }
                      })
                    ]
                  }
                }
              ])
            }),
            _c("vxe-column", {
              attrs: {
                field: "BASE_UNIT",
                title: _vm.$t("EditTable.BASE_UNIT"),
                "min-width": "150",
                "edit-render": {
                  enabled: _vm.canEdit,
                  autofocus: ".vxe-input--inner"
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "edit",
                  fn: function(ref) {
                    var row = ref.row
                    return [
                      _c("vxe-input", {
                        attrs: { type: "text", disabled: false },
                        model: {
                          value: row.PO_UNIT,
                          callback: function($$v) {
                            _vm.$set(row, "PO_UNIT", $$v)
                          },
                          expression: "row.PO_UNIT"
                        }
                      })
                    ]
                  }
                }
              ])
            }),
            _c("vxe-column", {
              attrs: {
                field: "UNIT_EXRATE",
                title: _vm.$t("EditTable.UNIT_EXRATE"),
                "min-width": "150",
                "edit-render": {
                  enabled: _vm.canEdit,
                  autofocus: ".vxe-input--inner"
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "edit",
                  fn: function(ref) {
                    var row = ref.row
                    return [
                      _c("vxe-input", {
                        attrs: { type: "number", disabled: false },
                        model: {
                          value: row.UNIT_EXRATE,
                          callback: function($$v) {
                            _vm.$set(row, "UNIT_EXRATE", $$v)
                          },
                          expression: "row.UNIT_EXRATE"
                        }
                      })
                    ]
                  }
                }
              ])
            }),
            _c("vxe-column", {
              attrs: {
                formatter: _vm.vxeFormatDate,
                field: "DATE_CODE",
                title: _vm.$t("EditTable.DATE_CODE"),
                "min-width": "150",
                "edit-render": {
                  enabled: _vm.canEdit,
                  autofocus: ".vxe-input--inner"
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "edit",
                  fn: function(ref) {
                    var row = ref.row
                    return [
                      _c("vxe-input", {
                        attrs: { type: "text", disabled: false },
                        model: {
                          value: row.DATE_CODE,
                          callback: function($$v) {
                            _vm.$set(row, "DATE_CODE", $$v)
                          },
                          expression: "row.DATE_CODE"
                        }
                      })
                    ]
                  }
                }
              ])
            }),
            _c("vxe-column", {
              attrs: {
                field: "LOT_NO",
                title: _vm.$t("EditTable.LOT_NO"),
                "min-width": "150",
                "edit-render": {
                  enabled: _vm.canEdit,
                  autofocus: ".vxe-input--inner"
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "edit",
                  fn: function(ref) {
                    var row = ref.row
                    return [
                      _c("vxe-input", {
                        attrs: { type: "number", disabled: false },
                        model: {
                          value: row.LOT_NO,
                          callback: function($$v) {
                            _vm.$set(row, "LOT_NO", $$v)
                          },
                          expression: "row.LOT_NO"
                        }
                      })
                    ]
                  }
                }
              ])
            }),
            _c("vxe-column", {
              attrs: {
                field: "ATTRIBUTE8",
                title: "LED_BIN",
                "min-width": "150",
                "edit-render": {
                  enabled: _vm.canEdit,
                  autofocus: ".vxe-input--inner"
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "edit",
                  fn: function(ref) {
                    var row = ref.row
                    return [
                      _c("vxe-input", {
                        attrs: { type: "text", disabled: false },
                        model: {
                          value: row.ATTRIBUTE8,
                          callback: function($$v) {
                            _vm.$set(row, "ATTRIBUTE8", $$v)
                          },
                          expression: "row.ATTRIBUTE8"
                        }
                      })
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }